import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddRegion = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [discom, setDiscom] = useState([]);
  const [discomId, setDiscomId] = useState([]);

  const [rowAddData, setRowAddData] = useState({
    region_name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const handleDiscomChange = (e) => {
    setDiscomId(e.target.value);
  };

  function resetFields() {
    setRowAddData({
      region_name: "",
    });
    setDiscomId("");
  }

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { region_name } = rowAddData;
    let BASE_URL = SERVER_URL + `/api/region/region-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discom_id: discomId,
        region_name,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getDiscom = async () => {
    const BASE_URL = SERVER_URL + `/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if(res.ok){
      setDiscom(result.data);
    }else{
      setDiscom([]);
    }
  };

  useEffect(() => {
    getDiscom();
  }, []);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Region
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Discom">Discom Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleDiscomChange}
                              value={discomId}
                              id="Discom"
                              required
                            >
                              <option value="">Select Discom</option>
                              {discom &&
                                discom?.length > 0 &&
                                discom?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.discom_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="region_name">Region Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="region_name"
                              id="region_name"
                              placeholder="Enter Region Name"
                              value={rowAddData.region_name}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRegion;
